document.addEventListener("DOMContentLoaded", () => {
  /* ----------------------------------------
      ELEMENTS & DEFAULT VALUES
  ----------------------------------------- */
  const wrapper = document.querySelector(".clinic-consultation-form");

  const defaultClinicArea = wrapper.dataset.defaultClinicArea || "";
  const defaultClinicCity = wrapper.dataset.defaultClinicCity || "";
  const commonEmail = wrapper.dataset.commonEmail || "";

  const form = document.getElementById("consultationForm");
  const preferredClinic = document.getElementById("preferredClinic");
  
  /* -------------------------------------------------------
  SHOW LABEL INSTEAD OF DROPDOWN IF ONLY ONE CLINIC EXISTS
--------------------------------------------------------- */
  function handleSingleClinicUI() {
    const selectWrapper = document.getElementById("clinicSelectWrapper");
    const labelBox = document.getElementById("singleClinicLabel");
    const options = Array.from(preferredClinic.options);

    if (options.length === 1) {
      const clinicName = options[0].textContent.trim();

      // Hide dropdown
      selectWrapper.style.display = "none";

      // Show simple text
      labelBox.style.display = "flex";
      labelBox.textContent = clinicName;

      // Add hidden input for submission
      if (!document.getElementById("hiddenSingleClinic")) {
        const hidden = document.createElement("input");
        hidden.type = "hidden";
        hidden.name = "preferredClinic";
        hidden.value = clinicName;
        hidden.id = "hiddenSingleClinic";
        labelBox.appendChild(hidden);
      }
    } else {
      // Multiple clinics → show dropdown
      selectWrapper.style.display = "";
      labelBox.style.display = "none";
    }
  }

  // Run immediately
  handleSingleClinicUI();

  const clinicMapItems = document.querySelectorAll(
    ".clinic-consultation-form__location-map-item"
  );
  const selectedLocationInput = document.getElementById("selectedLocation");
  const userLocationInput = document.getElementById("userLocation");

  const fullNameInput = document.getElementById("fullName");
  const countryCodeSelect = document.getElementById("countryCode");
  const phoneInput = document.getElementById("phoneNumber");
  
  // Optional fields - check if they exist
  const dateInput = document.getElementById("preferredDate");
  const timeInput = document.getElementById("preferredTime");
  const healthConcernInput = document.getElementById("preferredHealthConcern");

  /* ----------------------------------------
      HELPERS — Error Messages
  ----------------------------------------- */
  function showError(field, message) {
    const span = document.querySelector(`.error-text[data-error="${field}"]`);
    if (span) span.textContent = message;
  }

  function clearError(field) {
    const span = document.querySelector(`.error-text[data-error="${field}"]`);
    if (span) span.textContent = "";
  }

  /* ----------------------------------------
      FULL NAME — letters only
  ----------------------------------------- */
  fullNameInput.addEventListener("input", () => {
    fullNameInput.value = fullNameInput.value.replace(/[^A-Za-z ]+/g, "");
  });

  /* ----------------------------------------
      PHONE — max length per country
  ----------------------------------------- */

  const phoneLengthMap = {
    "+91": 10, // India
    "+65": 8, // Singapore
    "+1": 10, // USA
  };

  function updatePhoneMaxLength() {
    const selected = countryCodeSelect.value;
    const maxLen = phoneLengthMap[selected] || 10;

    phoneInput.maxLength = maxLen;
    phoneInput.placeholder = `${maxLen} digits`;

    if (phoneInput.value.length > maxLen) {
      phoneInput.value = phoneInput.value.slice(0, maxLen);
    }
  }

  countryCodeSelect.addEventListener("change", updatePhoneMaxLength);

  phoneInput.addEventListener("input", () => {
    const selected = countryCodeSelect.value;
    const maxLen = phoneLengthMap[selected] || 10;

    phoneInput.value = phoneInput.value.replace(/[^0-9]/g, "");

    if (phoneInput.value.length > maxLen) {
      phoneInput.value = phoneInput.value.slice(0, maxLen);
    }
  });

  updatePhoneMaxLength();

  /* ----------------------------------------
      PHONE REGEX VALIDATION
  ----------------------------------------- */
  function validatePhone(country, num) {
    const patterns = {
      "+91": /^[6-9]\d{9}$/, // India
      "+65": /^[89]\d{7}$/, // Singapore
      "+1": /^(?:\+1\s?)?[2-9]\d{2}[2-9]\d{6}$/, // USA
    };
    return patterns[country]?.test(num) || false;
  }

  /* ----------------------------------------
      ✅ DATE & TIME — Only if fields exist
  ----------------------------------------- */
  if (dateInput && timeInput) {
    function getLocalToday() {
      const d = new Date();
      return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(
        2,
        "0"
      )}-${String(d.getDate()).padStart(2, "0")}`;
    }

    const todayStr = getLocalToday();
    dateInput.setAttribute("min", todayStr);

    /* ----------------------------------------
        ✅ BUILD TIME OPTIONS (9:00 AM – 6:00 PM)
    ----------------------------------------- */
    function buildTimeOptions() {
      timeInput.innerHTML = `<option value="">Select a time</option>`;

      for (let hour = 9; hour <= 18; hour++) {
        for (let min of [0, 30]) {
          if (hour === 18 && min === 30) continue;

          const rawValue = `${hour}:${min === 0 ? "00" : "30"}`;

          const d = new Date();
          d.setHours(hour, min);

          const label = d.toLocaleTimeString([], {
            hour: "numeric",
            minute: "2-digit",
            hour12: true,
          });

          const option = document.createElement("option");
          option.value = rawValue;
          option.textContent = label;
          timeInput.appendChild(option);
        }
      }
    }

    buildTimeOptions();

    function disableTodayIfClosed() {
      const now = new Date();
      const cutoff = new Date();
      cutoff.setHours(18, 0, 0, 0);

      if (now >= cutoff) {
        const t = new Date(now);
        t.setDate(t.getDate() + 1);

        const yyyy = t.getFullYear();
        const mm = String(t.getMonth() + 1).padStart(2, "0");
        const dd = String(t.getDate()).padStart(2, "0");
        const tomorrow = `${yyyy}-${mm}-${dd}`;

        dateInput.min = tomorrow;
        dateInput.value = tomorrow;

        timeInput.value = "";
        filterTimes();
      }
    }

    disableTodayIfClosed();

    /* ----------------------------------------
        ✅ DISABLE PAST TIMES FOR TODAY
    ----------------------------------------- */
    function filterTimes() {
      if (!dateInput.value) return;

      const now = new Date();

      Array.from(timeInput.options).forEach((opt) => {
        if (!opt.value) return;

        const [hourStr, minuteStr] = opt.value.split(":");
        const h = parseInt(hourStr);
        const m = parseInt(minuteStr);

        const selected = new Date(dateInput.value);
        selected.setHours(h, m, 0, 0);

        opt.disabled = selected <= now;
      });

      if (timeInput.selectedOptions[0]?.disabled) {
        timeInput.value = "";
      }
    }

    dateInput.addEventListener("change", filterTimes);
    timeInput.addEventListener("focus", filterTimes);
    window.addEventListener("load", filterTimes);
  }

  /* ----------------------------------------
      DEFAULT CLINIC & DEFAULT MAP
  ----------------------------------------- */
  let defaultClinicName = defaultClinicArea.trim();
  const clinicOptions = [...preferredClinic.options].filter(
    (o) => o.value !== ""
  );

  if (
    !defaultClinicName ||
    !clinicOptions.some((o) => o.value === defaultClinicName)
  ) {
    defaultClinicName = clinicOptions[0]?.value || "";
  }

  preferredClinic.value = defaultClinicName;

  clinicMapItems.forEach((i) => (i.style.display = "none"));
  let selectedClinicEmail = "";
  let selectedClinicPhones = ""; // Store clinic admin phones

  const defaultMap = document.querySelector(
    `.clinic-consultation-form__location-map-item[data-clinic-name="${CSS.escape(
      defaultClinicName
    )}"]`
  );

  if (defaultMap) {
    defaultMap.style.display = "block";
    selectedLocationInput.value = defaultMap.dataset.clinicLocation;
    selectedClinicEmail = defaultMap.dataset.clinicEmail || "";
    selectedClinicPhones = defaultMap.dataset.clinicPhones || "";
  }

  preferredClinic.addEventListener("change", () => {
    const selected = preferredClinic.value;

    clinicMapItems.forEach((item) => {
      if (item.dataset.clinicName === selected) {
        item.style.display = "block";
        selectedLocationInput.value = item.dataset.clinicLocation;
        selectedClinicEmail = item.dataset.clinicEmail || "";
        selectedClinicPhones = item.dataset.clinicPhones || "";
      } else {
        item.style.display = "none";
      }
    });
  });

  /* ----------------------------------------
    BLUR VALIDATIONS
  ----------------------------------------- */
  fullNameInput.addEventListener("blur", () => {
    const value = fullNameInput.value.trim();
    if (value && value.length < 3) {
      showError("fullName", "Enter a valid full name");
    } else clearError("fullName");
  });

  phoneInput.addEventListener("blur", () => {
    const country = countryCodeSelect.value;
    const phone = phoneInput.value.trim();

    if (phone && !validatePhone(country, phone)) {
      showError("phoneNumber", "Invalid phone number");
    } else clearError("phoneNumber");
  });

  /* ----------------------------------------
      ✅ VALIDATE FORM ON SUBMIT
  ----------------------------------------- */
  function validateForm() {
    let valid = true;

    // Always validate name
    if (fullNameInput.value.trim().length < 3) {
      showError("fullName", "Enter a valid full name");
      valid = false;
    } else clearError("fullName");

    // Always validate phone
    const country = countryCodeSelect.value;
    const phone = phoneInput.value.trim();

    if (!validatePhone(country, phone)) {
      showError("phoneNumber", "Invalid phone number");
      valid = false;
    } else clearError("phoneNumber");

    // Only validate date if field exists AND is required
    if (dateInput && dateInput.hasAttribute('required')) {
      if (!dateInput.value) {
        showError("preferredDate", "Select a date");
        valid = false;
      } else clearError("preferredDate");
    }

    // Only validate time if field exists AND is required
    if (timeInput && timeInput.hasAttribute('required')) {
      if (!timeInput.value) {
        showError("preferredTime", "Select a time");
        valid = false;
      } else {
        const [h, m] = timeInput.value.split(":").map(Number);
        const selectedDT = new Date(dateInput.value);
        selectedDT.setHours(h, m, 0, 0);

        if (selectedDT <= new Date()) {
          showError("preferredTime", "Select a future time");
          valid = false;
        } else clearError("preferredTime");
      }
    }

    if (!preferredClinic.value) {
      showError("preferredClinic", "Select a clinic");
      valid = false;
    } else clearError("preferredClinic");

    return valid;
  }

  /* ----------------------------------------
      SUCCESS MESSAGE + LOADING
  ----------------------------------------- */
  const successMsg = document.createElement("div");
  successMsg.className = "clinic-consultation-form__success";
  successMsg.innerHTML =
    "We have received your request and will contact you soon. Thank you for choosing Kerala Ayurveda!";
  successMsg.style.display = "none";
  form.appendChild(successMsg);

  const submitBtn = form.querySelector("button[type='submit']");

  function showLoading() {
    submitBtn.classList.add("loading");
    submitBtn.disabled = true;
  }

  function hideLoading() {
    submitBtn.classList.remove("loading");
    submitBtn.disabled = false;
  }

  function convertTo12Hour(time24) {
    const [h, m] = time24.split(":").map(Number);
    const hours12 = ((h + 11) % 12) + 1;
    const ampm = h >= 12 ? "PM" : "AM";
    return `${hours12}:${m.toString().padStart(2, "0")} ${ampm}`;
  }

  /* ----------------------------------------
      FORM SUBMISSION
  ----------------------------------------- */
  form.addEventListener("submit", (e) => {
    e.preventDefault();

    if (!validateForm()) return;

    showLoading();

    const enableCityLocation = wrapper.dataset.enableCityLocation === "true";

    let finalLocation = enableCityLocation
      ? userLocationInput?.value || selectedLocationInput.value
      : defaultClinicCity;

    const formData = new FormData();
    formData.append("fullName", fullNameInput.value.trim());
    formData.append("phone", phoneInput.value.trim());
    formData.append("countryCode", countryCodeSelect.value);
    
    // Only append date/time if fields exist
    if (dateInput && dateInput.value) {
      formData.append("date", dateInput.value);
    }
    
    if (timeInput && timeInput.value) {
      formData.append("time", convertTo12Hour(timeInput.value));
    }
    
    // Only append health concern if field exists
    if (healthConcernInput && healthConcernInput.value) {
      formData.append("healthConcern", healthConcernInput.value);
    }
    
    formData.append("clinic", preferredClinic.value);
    formData.append("location", finalLocation);
    formData.append("emailTo", selectedClinicEmail);
    formData.append("commonEmail", commonEmail);
    formData.append("clinicPhones", selectedClinicPhones); // Pass clinic admin phones

    // Show success immediately (Optimistic UI)
    setTimeout(() => {
      hideLoading();
      successMsg.style.display = "block";
      form.reset();
      updatePhoneMaxLength();
      
      if (timeInput) {
        buildTimeOptions();
        filterTimes();
      }

      setTimeout(() => {
        successMsg.style.display = "none";
      }, 5000);

      preferredClinic.value = defaultClinicName;
      selectedClinicEmail = defaultMap?.dataset.clinicEmail || "";
    }, 1000);

    // Fire & Forget - Send in background
    fetch(
      "https://script.google.com/macros/s/AKfycbzHOf44PNyXS_TyqqAfoZwa1Skxn7FVrJvsEBHMBg10Qor16EO3s9pG_Tks93OEXpZhdQ/exec",
      {
        method: "POST",
        body: formData,
        keepalive: true
      }
    )
      .then((r) => r.json())
      .then((data) => {
        // Form submitted successfully;
      })
      .catch((error) => {
        console.warn("Background error:", error);
      });
  });
});

document.addEventListener("DOMContentLoaded", () => {
  const banner = document.getElementById("other-cities-banner");
  if (!banner) return;

  const clinicCity = banner.dataset.clinicCity.toLowerCase().trim();
  const cityList = banner.dataset.cityList.split("|").map((c) => c.trim());
  const citiesContainer = document.getElementById("cities-container");

  // Render the cities list (• separated)
  citiesContainer.innerHTML = cityList.join(" • ");

  // Fetch user's city
  fetch("https://ipapi.co/json/")
    .then((res) => res.json())
    .then((data) => {
      const userCity = (data.city || "").toLowerCase().trim();

      if (userCity !== clinicCity) {
        banner.style.display = "block";
      } else {
        banner.style.display = "none";
      }
    })
    .catch((err) => {
      console.warn("Location fetch failed", err);
      banner.style.display = "block";
    });
});
